export default __webpack_public_path__ + "static/GreycliffCF-Heavy-9b33c66a967e2d89746d021204b49906.woff2";